import { supabase } from "@/services/supabase/client";
import type { SortOrder } from "@/services/api/incompleteUsers";

export type DeletedUserSortBy =
  | "display_name"
  | "created_at"
  | "deleted_at"
  | "gig_count"
  | "ww_count"
  | "dm_count";

export interface DeletedUser {
  id: string;
  display_name: string | null;
  roles?: string[] | null;
  created_at: string;
  deleted_at: string;
  plan?: string | null;
  gig_count: number;
  ww_count: number;
  dm_count: number;
}

export interface DeletedUsersResponse {
  items: DeletedUser[];
  total: number;
  has_more: boolean;
}

export interface GetDeletedUsersParams {
  limit: number;
  offset: number;
  search?: string | null | undefined;
  sortBy?: DeletedUserSortBy;
  sortOrder?: SortOrder;
}

interface RpcEnvelope {
  ok: boolean;
  error?: string;
  items?: DeletedUser[];
  total?: number;
  has_more?: boolean;
}

const getDeletedUsers = async ({
  limit,
  offset,
  search,
  sortBy,
  sortOrder = "desc",
}: GetDeletedUsersParams): Promise<DeletedUsersResponse> => {
  const { data, error } = await supabase.rpc("get_admin_delete_users", {
    _limit: limit,
    _offset: offset,
    _sort_order: sortOrder,
    ...(sortBy ? { _sort_by: sortBy } : {}),
    ...(search ? { _query_text: search } : {}),
  });

  if (error) {
    console.error("getDeletedUsers error:", error);
    throw new Error(error.message || "Failed to fetch deleted users");
  }

  const result = data as RpcEnvelope;
  if (!result?.ok) {
    throw new Error(result?.error || "Failed to fetch deleted users");
  }

  return {
    items: result.items ?? [],
    total: result.total ?? 0,
    has_more: result.has_more ?? false,
  };
};

const DeletedUsersService = { getDeletedUsers };

export default DeletedUsersService;
